import { render, staticRenderFns } from "./AlertRuleForm.vue?vue&type=template&id=861f8932&"
import script from "./AlertRuleForm.vue?vue&type=script&lang=js&"
export * from "./AlertRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports